(function () {
  const STORAGE_KEY = 'rachelis-a11y';
  const TEXT_LEVELS = ['text-1', 'text-2', 'text-3'];
  const TEXT_LABELS = ['גודל רגיל', 'טקסט מוגדל', 'טקסט מוגדל מאוד', 'טקסט מוגדל במיוחד'];
  const root = document.documentElement;
  const widget = document.querySelector('[data-rachelis-a11y]');
  if (!widget) return;

  const toggle = widget.querySelector('[data-a11y-toggle]');
  const panel = widget.querySelector('#RachelisA11yPanel');
  const title = widget.querySelector('#RachelisA11yTitle');
  const textStatus = widget.querySelector('[data-a11y-text-status]');

  function readPrefs() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  let prefs = readPrefs();

  function savePrefs() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    } catch (e) {}
  }

  function textLevel() {
    return TEXT_LEVELS.findIndex((key) => prefs[key]) + 1;
  }

  function apply() {
    Object.keys(prefs).forEach((key) => root.classList.toggle('a11y-' + key, Boolean(prefs[key])));
    TEXT_LEVELS.forEach((key) => {
      if (!prefs[key]) root.classList.remove('a11y-' + key);
    });
    widget.querySelectorAll('[data-a11y-flag]').forEach((button) => {
      button.setAttribute('aria-pressed', String(Boolean(prefs[button.dataset.a11yFlag])));
    });
    textStatus.textContent = TEXT_LABELS[textLevel()];
    document.dispatchEvent(new CustomEvent('rachelis:a11y-change', { detail: { ...prefs } }));
  }

  function setTextLevel(level) {
    TEXT_LEVELS.forEach((key, index) => {
      prefs[key] = index + 1 === level;
    });
  }

  function open() {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    title.focus();
  }

  function close(returnFocus) {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    if (returnFocus) toggle.focus();
  }

  toggle.addEventListener('click', () => (panel.hidden ? open() : close(false)));
  widget.querySelector('[data-a11y-close]').addEventListener('click', () => close(true));

  widget.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) {
      event.stopPropagation();
      close(true);
    }
  });

  document.addEventListener('click', (event) => {
    if (!panel.hidden && !widget.contains(event.target)) close(false);
  });

  widget.querySelectorAll('[data-a11y-text]').forEach((button) => {
    button.addEventListener('click', () => {
      const step = button.dataset.a11yText === 'up' ? 1 : -1;
      setTextLevel(Math.min(TEXT_LEVELS.length, Math.max(0, textLevel() + step)));
      savePrefs();
      apply();
    });
  });

  widget.querySelectorAll('[data-a11y-flag]').forEach((button) => {
    button.addEventListener('click', () => {
      const flag = button.dataset.a11yFlag;
      prefs[flag] = !prefs[flag];
      savePrefs();
      apply();
    });
  });

  widget.querySelector('[data-a11y-reset]').addEventListener('click', () => {
    Object.keys(prefs).forEach((key) => root.classList.remove('a11y-' + key));
    prefs = {};
    savePrefs();
    apply();
  });

  apply();
})();
